import { render, staticRenderFns } from "./BindsOptgroup.vue?vue&type=template&id=e8459dfe&"
import script from "./BindsOptgroup.vue?vue&type=script&lang=js&"
export * from "./BindsOptgroup.vue?vue&type=script&lang=js&"
import style0 from "./BindsOptgroup.vue?vue&type=style&index=0&id=e8459dfe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports